import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    overflow: 'hidden',
    minHeight: 150,
  },
  blur: {
    filter: 'blur(6px)',
  },
  cover: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    background: 'rgba(255, 255, 255, 0.75)',
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
});

const BlurWrapper = ({ active, children, content }) => {
  const classes = useStyles();

  return active ? (
    <Card>
      <div className={classes.root}>
        <div className={classes.cover} />
        <div className={classes.content}>{content}</div>
        <div className={classes.blur}>{children}</div>
      </div>
    </Card>
  ) : (
    children
  );
};

BlurWrapper.defaultProps = {
  active: true,
  content: null,
};

BlurWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node,
  active: PropTypes.bool,
};

export default BlurWrapper;
